import './tableData.scss'
import {useEffect, useState} from "react";
import {
    Table,
    Thead,
    Tbody,
    Tfoot,
    Tr,
    Th,
    Td,
    TableCaption,
    TableContainer,
} from '@chakra-ui/react'
import {formatOra} from "../../utilities/formatDate";
import {formatStrategyName} from "../../utilities/formatStrategyName";

const TableData = ({actualStep, data, filter}) => {
    const [filteredData, setFilteredData] = useState(data);

    // Funzione per parsare i log del primo tab (Security)
    const parseSecurityLog = (msg) => {
        if (!msg) return null;

        // Formato: "NOG | open: 22.62 | previousClose: 21.8 | gap percentage: 0.03761467889908258"
        const parts = msg.split('|').map(p => p.trim());

        if (parts.length < 4) return null;

        const security = parts[0];
        const open = parts[1]?.replace('open:', '').trim();
        const previousClose = parts[2]?.replace('previousClose:', '').trim();
        const gapRaw = parts[3]?.replace('gap percentage:', '').trim();
        const gap = gapRaw ? (parseFloat(gapRaw) * 100).toFixed(2) + '%' : '-';

        return { security, open, previousClose, gap };
    };

    useEffect(() => {
        if (!data && !filter && !actualStep) return;

        let processedData = [...data]; // Copia array per non mutare l'originale

        // Ordina per timestamp decrescente (più recenti in cima)
        processedData.sort((a, b) => {
            const dateA = new Date(a.ts_event_iso);
            const dateB = new Date(b.ts_event_iso);
            return dateB - dateA; // Ordine decrescente
        });

        // Applica filtro se presente
        if (!filter) {
            setFilteredData(processedData);
            return;
        }

        if (actualStep !== 0) {
            setFilteredData(processedData.filter(row =>
                row.security.toLowerCase() === filter.toLowerCase()
            ));
        } else {
            setFilteredData(processedData.filter(row =>
                row.msg.toLowerCase().includes(filter.toLowerCase())
            ));
        }
    }, [actualStep, data, filter]);

    return (
        <TableContainer
            maxH="calc(100vh - 350px)"
            overflowY="auto"
            sx={{
                '&::-webkit-scrollbar': {
                    width: '8px',
                },
                '&::-webkit-scrollbar-track': {
                    background: '#f1f1f1',
                },
                '&::-webkit-scrollbar-thumb': {
                    background: '#888',
                    borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: '#555',
                },
            }}
        >
            <Table variant='simple' className="table">
                {actualStep === 0 && <TableCaption>Selected Securities by Gap Percentage</TableCaption>}
                {actualStep === 1 && <TableCaption>Securities Passed First Bar</TableCaption>}
                {actualStep === 2 && <TableCaption>Securities Passed Second Bar</TableCaption>}
                {actualStep === 3 && <TableCaption>Let the trade Begin </TableCaption>}

                <Thead position="sticky" top={0} bg="white" zIndex={1}>
                    <Tr>
                        {actualStep === 0 ? (
                            // Header per il primo tab (Security)
                            <>
                                <Th>Security</Th>
                                <Th>Open</Th>
                                <Th>Previous Close</Th>
                                <Th>Gap</Th>
                                <Th>Ora</Th>
                            </>
                        ) : (
                            // Header per gli altri tab
                            <>
                                {data && data[0]['security'] ? (
                                    <Th>Security</Th>
                                ) : ''}
                                <Th>Logs</Th>
                                <Th>Ora</Th>
                            </>
                        )}
                    </Tr>
                </Thead>
                <Tbody>
                    {filteredData?.map((row, index) => {
                        if (actualStep === 0) {
                            // Parsing per il primo tab
                            const parsed = parseSecurityLog(row.msg);
                            if (!parsed) {
                                // Fallback se il parsing fallisce
                                return (
                                    <Tr key={index}>
                                        <Td colSpan={5} whiteSpace="normal" wordBreak="break-word">{row.msg}</Td>
                                    </Tr>
                                );
                            }
                            return (
                                <Tr key={index}>
                                    <Td>{parsed.security}</Td>
                                    <Td>{parsed.open}</Td>
                                    <Td>{parsed.previousClose}</Td>
                                    <Td>{parsed.gap}</Td>
                                    <Td>{formatOra(row.ts_event_iso)}</Td>
                                </Tr>
                            );
                        } else {
                            // Visualizzazione normale per gli altri tab
                            return (
                                <Tr key={index}>
                                    {row?.security ? (
                                        <Td>{row.security}</Td>
                                    ) : ''}
                                    <Td whiteSpace="normal" wordBreak="break-word">{row.msg}</Td>
                                    <Td>{formatOra(row.ts_event_iso)}</Td>
                                </Tr>
                            );
                        }
                    })}
                </Tbody>
            </Table>
        </TableContainer>
    );
}

export default TableData;